import React, { useEffect, useState } from "react";
import Button, {
  ButtonTypes,
  ButtonColorTypes,
} from "../shared-components/Button";
import { XIcon } from "../shared-components/icons";
import InputField from "../shared-components/InputField";
import Divider from "../shared-components/LineDivider";
import { classNames, uniqueUUID } from "../utils";
import { PersonFormStateError } from "./PersonFormErrorState";

export interface PhoneDefinitions {
  key: string;
  phone: string;
}

type Props = {
  onChange?: (aliases: PhoneDefinitions[]) => void;
  error?: PersonFormStateError;
  prefill?: PhoneDefinitions[];
  alternateColor?: boolean;
};

function buildEmptyDefinition(): PhoneDefinitions {
  return { phone: "", key: uniqueUUID() };
}

const PersonFormPhones = ({
  onChange,
  error,
  prefill,
  alternateColor,
}: Props) => {
  const [fieldsList, setFields] = useState<PhoneDefinitions[]>([]);

  useEffect(() => {
    if (prefill && prefill.length > 0) {
      handleChange([...prefill]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefill]);

  const appendFields = () => {
    handleChange([...fieldsList, buildEmptyDefinition()]);
  };

  const updateField = (idx: number, field: "phone", value: string) => {
    fieldsList[idx][field] = value;
    handleChange([...fieldsList]);
  };

  const removeField = (idx: number) => {
    fieldsList.splice(idx, 1);
    handleChange([...fieldsList]);
  };

  const handleChange = (list: PhoneDefinitions[]) => {
    onChange?.(list);
    setFields(list);
  };

  const handleAdd = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    appendFields();
  };

  const handleRemove = (idx: number) => {
    removeField(idx);
  };
  return (
    <>
      <div>
        {fieldsList.map((fields, idx) => (
          <div
            key={fields.key}
            className={classNames(
              "flex flex-wrap items-center",
              idx > 0 ? "mt-4" : ""
            )}
          >
            <InputField
              handleChange={(e) => {
                updateField(idx, "phone", e.target.value);
              }}
              defaultValue={fields.phone}
              name={`phone-${idx}`}
              placeholder=""
              label={"Phone number"}
              type="text"
              className={`${error?.phones?.[idx] ? "border-rose-600" : ""}`}
            />
            {fieldsList.length >= 0 && (
              <span className="pl-2 h-0">
                <div
                  className="rounded-full bg-gray-50 border p-1 text-gray-500 cursor-pointer"
                  onClick={(e) => handleRemove(idx)}
                >
                  <XIcon />
                </div>
              </span>
            )}
          </div>
        ))}
      </div>
      <Divider className="mb-6" />
      <Button
        type={ButtonTypes.add}
        text="Add Phone Number"
        colorType={
          alternateColor ? ButtonColorTypes.alternate : ButtonColorTypes.action
        }
        onClick={handleAdd}
      />
    </>
  );
};

export default PersonFormPhones;
